module.exports = __webpack_public_path__ + "static/media/ic_close.82471f5e.svg";